module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-btn-group', {
    staticClass: "pull-right"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "title": "Kavel toevoegen",
      "exact": "",
      "to": {
        name: 'itemAdd'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  })])], 1), _vm._v(" "), _c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('item.items')))]), _vm._v(" "), _c('div', {
    staticClass: "my-1 row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6"
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "off",
      "placeholder": _vm.$t('item.searchPlaceholder')
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pic_count),
      expression: "pic_count"
    }],
    staticClass: "mdb-select my-3 md-form pull-right",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pic_count = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterData]
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Met en zonder foto's")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Met foto's")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Zonder foto's")])]), _vm._v(" "), _c('b-button', {
    staticClass: "my-3",
    attrs: {
      "disabled": !_vm.sortBy,
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.resetSorting(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.resetSort')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6"
  }, [_c('autocomplete-person', {
    attrs: {
      "label": null,
      "selected": _vm.selectedSellerId
    },
    on: {
      "update:person": _vm.onUpdateFilterSeller
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-12"
  }, [_c('b-pagination-nav', {
    staticClass: "pull-right",
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.auctionItems.meta.totalPages,
      "value": _vm.auctionItems.meta.currentPage,
      "use-router": ""
    }
  })], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.auctionItems.isFetching
    }
  }), _vm._v(" "), (!_vm.auctionItems.isFetching) ? _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "items": _vm.auctionItems.items,
      "fields": _vm.fields,
      "per-page": parseInt(_vm.auctionItems.meta.perPage),
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "no-local-sorting": true,
      "empty-text": _vm.$t('item.listEmptyText'),
      "empty-filtered-text": _vm.$t('item.listEmptyFilteredText')
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      },
      "sort-changed": _vm.onSortingChanged
    },
    scopedSlots: _vm._u([{
      key: "cell(media)",
      fn: function(row) {
        return [(row.item.media[0]) ? _c('b-img-lazy', {
          attrs: {
            "width": _vm.imgSize,
            "src": _vm.small(row.item.media[0].url)
          }
        }) : _c('b-img', {
          attrs: {
            "blank": "",
            "blank-color": "#ccc",
            "width": _vm.imgSize,
            "height": _vm.imgSize
          }
        })]
      }
    }, {
      key: "cell(auction_order_number)",
      fn: function(row) {
        return [(row.item.auction_order_number) ? _c('span', [_vm._v(_vm._s(row.item.auction_order_number))]) : _c('span', [_c('i', [_vm._v("-")])])]
      }
    }, {
      key: "cell(number)",
      fn: function(row) {
        return [_vm._v("\n\t\t\t\t" + _vm._s(row.item.seller.code) + "-" + _vm._s(row.item.number) + "\n        ")]
      }
    }, {
      key: "cell(title)",
      fn: function(row) {
        return [_c('strong', [_vm._v(_vm._s(row.item.title))]), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(row.item.description))])]
      }
    }, {
      key: "cell(category)",
      fn: function(row) {
        return [(row.item.category.abbreviation) ? _c('span', {
          staticClass: "titletip",
          class: {
            on: row.item.id == _vm.curHoverID
          }
        }, [_vm._v(_vm._s(row.item.category.title))]) : _vm._e(), _vm._v(" "), (row.item.category.abbreviation) ? _c('span', {
          staticClass: "afk",
          on: {
            "mouseout": function($event) {
              _vm.curHoverID = false
            },
            "mouseover": function($event) {
              _vm.curHoverID = row.item.id
            }
          }
        }, [_vm._v(_vm._s(row.item.category.abbreviation))]) : _vm._e(), _vm._v(" "), (!row.item.category.abbreviation) ? _c('span', [_vm._v(_vm._s(row.item.category.slug))]) : _vm._e()]
      }
    }, {
      key: "cell(buyer)",
      fn: function(row) {
        return [(row.item.bid) ? _c('div', [_vm._v("\n\t\t\t\t" + _vm._s(row.item.bid.bid_number) + "\n\t\t\t")]) : _c('div', [_c('i', [_vm._v("-")])])]
      }
    }, {
      key: "cell(price)",
      fn: function(row) {
        return [(row.item.bid) ? _c('div', [_vm._v("\n\t\t\t\t" + _vm._s(Math.round(row.item.bid.price)) + "\n\t\t\t")]) : _c('div', [_c('i', [_vm._v("-")])])]
      }
    }, {
      key: "cell(actions)",
      fn: function(row) {
        return [_c('b-button-group', {
          staticClass: "pull-right"
        }, [_c('b-btn', {
          staticClass: "btn-sm",
          attrs: {
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteModal(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-trash"
        })]), _c('odbbarcode', {
          attrs: {
            "item": row.item,
            "aucdates": _vm.aucdates,
            "type": 'icon'
          }
        }), _vm._v(" "), _c('b-btn', {
          staticClass: "btn-sm",
          attrs: {
            "variant": "outline-primary",
            "to": {
              name: 'item',
              params: {
                itemId: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-eye"
        })]), _vm._v(" "), _c('b-btn', {
          staticClass: "btn-sm",
          attrs: {
            "variant": "outline-primary",
            "to": {
              name: 'itemEdit',
              params: {
                itemId: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-edit"
        })])], 1)]
      }
    }, {
      key: "cell(limit)",
      fn: function(row) {
        return [(row.item.limit) ? _c('span', [_vm._v(_vm._s(Math.round(row.item.limit)))]) : _vm._e()]
      }
    }, {
      key: "cell(target_price_1)",
      fn: function(row) {
        return [(row.item.target_price_1) ? _c('span', [_vm._v(_vm._s(Math.round(row.item.target_price_1)))]) : _vm._e(), _vm._v(" "), (row.item.target_price_2) ? _c('span', [(row.item.target_price_1) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v("\n\t\t\t\t" + _vm._s(Math.round(row.item.target_price_2)) + "\n\t\t\t")]) : _vm._e()]
      }
    }], null, false, 2929310113)
  }) : _vm._e(), _vm._v(" "), _c('b-pagination-nav', {
    staticClass: "pull-right",
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.auctionItems.meta.totalPages,
      "value": _vm.auctionItems.meta.currentPage,
      "use-router": ""
    }
  }), _vm._v(" "), _c('delete-dialog-modal', {
    ref: "deleteModal",
    attrs: {
      "delete-name": _vm.selectedDeleteItemName,
      "item": _vm.selectedDeleteItem,
      "isDeleting": _vm.isDeleting
    },
    on: {
      "confirm": _vm.deleteItem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a173d0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Item/ItemList.vue
// module id = 1296
// module chunks = 1